interface StepConfiguration {
	step: number;
	stepTitle: string;
  stepTitleKey?: string;
	title: string;
	titleKey: string; // < corresponds to a locale translation key
	subtitle?: string;
	subtitleKey?: string; // < corresponds to a locale translation key
}

export const FOUR_STEPS: StepConfiguration[] = [
	{
		step: 1,
		stepTitle: 'About You',
		title: 'About You',
		titleKey: 'aboutYou',
	},
	{
		step: 2,
		stepTitle: 'Patient Information',
		title: 'Patient Information',
		titleKey: 'patientInformation',
	},
	{
		step: 3,
		stepTitle: 'Location, Date, & Time',
		title: 'Location, Date, & Time',
		subtitle: "Click 'Confirm Consultation' to complete your scheduling.",
		subtitleKey: 'clickConfirmToComplete',
		titleKey: 'locationDateTime',
	},
	{
		step: 4,
		stepTitle: 'Confirmation',
		title: "You're all set, ",
		subtitle: 'Your consultation has been scheduled.',
		subtitleKey: 'consultationScheduled',
		titleKey: 'confirmation',
	},
];

export const THREE_STEPS: StepConfiguration[] = [
	{
		step: 1,
		stepTitle: 'Schedule your free consultation in 3 easy steps',
    stepTitleKey: 'threeSteps',
		title: 'About You',
		titleKey: 'aboutYou',
	},
	{
		step: 2,
		stepTitle: 'Schedule your free consultation in 3 easy steps',
    stepTitleKey: 'threeSteps',
		title: 'Patient Information',
		titleKey: 'patientInformation',
	},
	{
		step: 3,
		stepTitle: 'Schedule your free consultation in 3 easy steps',
    stepTitleKey: 'threeSteps',
		title: 'Location, Date, & Time',
		subtitle: "Click 'Confirm Consultation' to complete your scheduling.",
		subtitleKey: 'clickConfirmToComplete',
		titleKey: 'locationDateTime',
	},
  {
		step: 4,
		stepTitle: "You're all set",
    stepTitleKey: 'allSet',
		title: "You're all set, ",
		subtitle: 'Your consultation has been scheduled.',
		subtitleKey: 'consultationScheduled',
		titleKey: 'confirmation',
	},
];
